import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSectionList = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 37.377 28.911",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Listeseksjon",
		d: "M167.16,327.365V313.694h11.6v13.671Zm-12.8,0V313.694h11.433v13.671Zm-12.972,0V313.694h11.6v13.671Zm0,15.24V328.913h11.6V342.6Zm12.972,0V328.913h11.433V342.6Zm12.8,0V328.913h11.6V342.6Z",
		transform: "translate(-141.386 -313.694)"
	})
});
export default SvgSectionList;
